import { Component, inject, input } from '@angular/core';
import { CardVariant } from '@design-system/components/m-card';
import { SummaryMetricService } from '@portal/app/dashboard/context-modal/services/summary-metric.service';
import { ModalService } from '@portal/app/dashboard/context-modal/services/modal.service';
import { OmniModelViewType } from '@portal/app/shared/pipes/format-adjustment-factor-omni-value.pipe';

@Component({
  selector: 'portal-context-summary',
  templateUrl: './summary.component.html',
  providers: [SummaryMetricService]
})
export class SummaryComponent {
  public cardVariant = CardVariant;
  private summaryMetricService = inject(SummaryMetricService);
  private modalService = inject(ModalService);

  comparisonPeriod = input.required<string>();
  viewType = input<OmniModelViewType>('channel');

  isLoading = this.summaryMetricService.isLoading;
  isDataAvailable = this.summaryMetricService.isDataAvailable;
  topMetric = this.summaryMetricService.topMetric;
  drivers = this.summaryMetricService.drivers;
  isSpendLevel = this.modalService.isSpendLevel;
}
